import { render, staticRenderFns } from "./dutyManagement.vue?vue&type=template&id=a8cbaff4&scoped=true&"
import script from "./dutyManagement.vue?vue&type=script&lang=js&"
export * from "./dutyManagement.vue?vue&type=script&lang=js&"
import style0 from "./dutyManagement.vue?vue&type=style&index=0&id=a8cbaff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cbaff4",
  null
  
)

export default component.exports